module.exports = __webpack_public_path__ + "img/notarization.26ff6f20.png";